module.exports = __webpack_public_path__ + "img/vertical_3_2_5010.583195d7.png";